module.exports = __webpack_public_path__ + "img/shipment-returns-d.c1b2665.webp";